import styled from 'styled-components';
export var Action = styled.span.withConfig({
  displayName: "partials__Action",
  componentId: "sc-py4rhp-0"
})(["cursor:pointer;color:", ";transition:opacity 0.25s ease;&:hover{opacity:0.75;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.linkColor;
});